<template>
  <div id="nav">
    <div class="hd-trans" :style="{ opacity: curRouteName.includes('home') ?headOpacityFit.curOpacity:1}"></div>
    <div class="nav-wrap">
      <div class="nav-l" @click="toGxHome">
        <img class="logo" src="../../assets/images/ytHome/header_logo.png" />
        <!-- <div class="logo-text">西安市雁塔区智慧教育公众服务平台</div> -->
      </div>

      <div class="menus">
        <p @click='gotoUrl(1)' :class='{active:num==1}'>首页</p>
        <p @click='gotoUrl(2,globalData.imageColumnList[0])' :class='{active:num==2}'>教育资讯</p>
        <p @click='gotoUrl(3,globalData.columnList[0])' :class='{active:num==3}'>最新动态</p>
        <p @click='gotoUrl(4)' :class='{active:num==4}'>服务地图</p>
      </div>
      <div
        class="login"
        @click="toHomePageClick"
        v-if="userInfo"
      >
        进入空间
      </div>
      <el-popover
        placement="bottom"
        trigger="click"
        popper-class="hd_selec"
        v-if="userInfo"
      >
        <ul class="hd_user_pl user_info">
          <li @click="selectClick(1)" v-if="isShowAdminSign">
            {{ userInfo.currentAccountType === 1 ? "教育局管理" : "学校管理" }}
          </li>
          <li
            :class="curRouteName.includes('self') ? 'self_act' : ''"
            @click="selectClick(2)"
          >
            个人设置
          </li>
          <li @click="selectClick(3)">
            <img
              src="../../assets/images/ytHome/log_out.png"
              alt=""
            />
            退出登录
          </li>
        </ul>
        <div class="avatar-wrap" slot="reference">
          <img
            class="avater"
            @click="toHomePageClick"
            :src="
              userInfo.userPhoto || '../../assets/images/ytHome/def_header1.png'
            "
            alt=""
          />
          <el-tooltip
            class="item"
            effect="dark"
            :content="userInfo.userName"
            placement="top"
          >
            <span>{{ userInfo.userName }}</span>
          </el-tooltip>
          <i class="el-icon-caret-bottom"></i>
        </div>
      </el-popover>
      <div class="login" v-else @click="$_goToLogin()">登录</div>
    </div>
    <!-- <div class="nav-img"></div> -->
  </div>
</template>

<script>
  import {HomeGetUserManger} from "../../api/gxHome/api.home.js";
export default {
  components: {},
  data() {
    return {
      isShowAdminSign: false,
      num:this.$route.query.num||1,
    };
  },
  props: {
    headOpacityFit: {
      type: Object,
      default: () => {
        return {
          curOpacity: 1,
        };
      },
    }
  },
  computed: {
    userInfo() {
      return JSON.parse(window.sessionStorage.getItem("ssop_user_info"));
    },
    curRouteName() {
      return this.$route.name;
    },
    globalData() {
      return this.$store.state.globalData;
    }
  },
  created() {
    this.getUserManger();
  },
  mounted() {},
  methods: {
    toHomePageClick() {
      const userToken = window.sessionStorage.getItem("SSOP_TOKEN");
      let url = window.ENV_API.YT_URL + "route?token=" + userToken;
      window.location.href = url;
    },
    toGxHome() {
      this.$router.push("/yt/home");
    },
    selectClick(type) {
      // type 1 学校管理   2 个人设置  3 退出
      if (type === 1) {
        const url = ENV_API.CONSOLE_URL + "/console";
        window.open(url);
      } else if (type === 2) {
        const userToken = window.sessionStorage.getItem("SSOP_TOKEN");
        let url =
          window.ENV_API.YT_URL + "self/config-index?token=" + userToken;
        window.location.href = url;
        // this.$router.push({ name: "selfConfigIndex" });
      } else if (type === 3) {
        this.$_goToLogout();
      }
    },
    getUserManger() {
      const userId = this.userInfo && this.userInfo.userId;
      if (userId) {
        HomeGetUserManger(userId).then((res) => {
          if (res && res.code === "00000" && res.result) {
            this.isShowAdminSign = true;
          }
        });
      } else {
        setTimeout(() => {
          this.getUserManger();
        }, 1500);
      }
    },
    gotoUrl(type,item){
      if(type==1){//首页
        this.$router.push({name:'Home'});
        this.num=1;
      }else if(type==4){//map
        this.$router.push({name:'ytMap',query:{num:4}});
        this.num=4;
      }else{
        this.num=type;
        this.$router.push({
          path: "/yt/list",
          query: {
            tabName: item.columnName||'',
            num:type
          },
        });
      }
    }
  },
  watch:{
    $route(news,olds){
    //  console.log(news.query.num);
      let num=news.query.num;
      this.num=num;
    }
  }
};
</script>

<style scoped lang="scss">
.self_act {
  background-color: #e8f3fe;
  color: #740d09;
}
#nav {
  position: fixed;
  z-index: 2000;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  background: linear-gradient(#792621, rgba(121, 38, 33, 0.1) 60%, rgba(255, 255, 255, 0) 80%);
  // opacity: 0.48;
  // box-shadow: 0 0 5px #eee;
.hd-trans {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background-color: #853910;
    transition: all .3s;
    z-index: -1;
  }
  .nav-wrap {
    position: relative;
    width: 1200px;
    height: 70px;
    margin: 0 auto;
    display: flex;
    z-index: 2;
    .nav-l {
      .logo {
        height: 45px;
        margin-top: 13px;
        margin-right: 16px;
        cursor: pointer;
      }
      .logo-text {
        display: inline-block;
        font-size: 26px;
        font-weight: 500;
        color: #ffffff;
        line-height: 70px;
        vertical-align: top;
      }
      .nav-name {
        display: inline-block;
        font-size: 26px;
        color: #ffffff;
        margin-left: 49px;
        line-height: 80px;
      }
    }
    .menus{
      flex:1;
      overflow: hidden;
      padding-left: 60px;
      p{
        display: inline-block;
        margin:0px 20px;
        cursor: pointer;
        color:#fff;
        font-size:18px;
        line-height: 70px;
        position: relative;
        &.active{
          &::before{
            content:'';
            width:100%;
            height:4px;
            background:#fff;
            display: inline-block;
            position: absolute;
            bottom: 8px;
            border-radius: 3px;
          }
        }
      }
    }
    .btn {
      margin-top: 25px;
      border: 1px solid #ffffff;
      color: #ffffff;
      width: 80px;
      text-align: center;
      height: 38px;
      line-height: 38px;
      border-radius: 5px;
      font-size: 14px;
      cursor: pointer;
      margin-right: 5px;
    }
    .login {
      min-width: 84px;
      padding: 0px 10px;
      height: 38px;
      border-radius: 4px;
      border: 1px solid #ffffff;
      color: #ffffff;
      text-align: center;
      line-height: 38px;
      font-size: 14px;
      margin-top: 17px;
      cursor: pointer;
    }

    .avatar-wrap {
      align-self: center;
      display: flex;
      align-items: center;
      cursor: pointer;
      margin-left: 30px;
      margin-top: 15px;
      // line-height: 180px !important;
      .avater {
        height: 40px;
        width: 40px;
        border-radius: 100%;
      }
      span {
        font-size: 14px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #ffffff;
        margin-left: 10px;
        display: inline-block;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 130px;
        cursor: pointer;
      }
      i {
        margin-left: 6px;
        color: #ffffff;
      }
    }
    .nav-bar {
      position: relative;
      display: inline-block;
      width: auto;
      height: 100%;
      margin-left: 380px;
      a {
        position: relative;
        display: inline-block;
        text-decoration: none;
        width: auto;
        height: 80px;
        line-height: 80px;
        font-size: 18px;
        color: #333;
        padding: 0 30px;
        -webkit-transform: perspective(1px) translateZ(0);
        transform: perspective(1px) translateZ(0);

        &::before {
          content: "";
          position: absolute;
          z-index: -1;
          left: 51%;
          right: 51%;
          bottom: 13px;
          height: 2px;
          background: #498bff;
          -webkit-transition-property: left, right;
          transition-property: left, right;
          -webkit-transition-duration: 0.3s;
          transition-duration: 0.3s;
          -webkit-transition-timing-function: ease-out;
          transition-timing-function: ease-out;
        }
        &:hover {
          &::before {
            left: 35%;
            right: 35%;
          }
        }
      }
      .active {
        color: #498bff;
        font-weight: 600;
        &::before {
          left: 35%;
          right: 35%;
        }
      }
    }
  }
}

.hd_user_pl {
  li {
    text-align: center;
    width: 100%;
    height: 48px;
    line-height: 48px;
    cursor: pointer;
    &:hover {
      color: #740d09;
    }
    img{
      transform: translateY(3px)
    }
  }
  .self {
    background-color: #e8f3fe;
    color: #740d09;
  }
  .hd_logout {
    position: relative;
    // border-top: 1px solid #B7B6DA90;
    img {
      position: absolute;
      top: 13px;
      left: 26px;
    }
  }
}
</style>
